var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{attrs:{"src":_vm.setLinks.defaultLink,"alt":_vm.alt,"title":_vm.title,"srcset":((_vm.setLinks.doubleSizeLink) + " 2x")}})}
var staticRenderFns = []

export { render, staticRenderFns }